import React from "react";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import { makeStyles } from "@material-ui/core/styles";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
const useStyles = makeStyles(customInputStyle);

export default function HdiSeguros({ form, handleChange, buttonsSave }) {
  const classes = useStyles();
  return (
    <GridContainer xs={12} sm={12} md={8}>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Minimum premium"
          inputProps={{
            name: "minpremium",
            value: form.minpremium || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Commission (%)"
          inputProps={{
            name: "commission",
            value: form.commission || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          endAdornment="%"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Consumer commission (%)"
          inputProps={{
            name: "consumercom",
            value: form.consumercom || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          endAdornment="%"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Short term policy fee"
          inputProps={{
            name: "shortpolfee",
            value: form.shortpolfee || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Mid term policy fee"
          inputProps={{
            name: "midpolfee",
            value: form.midpolfee || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Long term policy fee"
          inputProps={{
            name: "longpolfee",
            value: form.longpolfee || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Short term agency fee"
          inputProps={{
            name: "shortagentfee",
            value: form.shortagentfee || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Mid term agency fee"
          inputProps={{
            name: "midagentfee",
            value: form.midagentfee || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Long term agency fee"
          inputProps={{
            name: "longagentfee",
            value: form.longagentfee || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="L.R. Surcharge (%)"
          inputProps={{
            name: "surcharge",
            value: form.surcharge || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          endAdornment="%"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Minimum PD Deductible"
          inputProps={{
            name: "minpd",
            value: form.minpd || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Minimum theft deductible"
          inputProps={{
            name: "mintheft",
            value: form.mintheft || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Agency fee"
          inputProps={{
            name: "agency_fee",
            value: form.agency_fee || "",
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
          startAdornment="$"
        />
      </GridItem>
      {buttonsSave()}
    </GridContainer>
  );
}
